export default "__VITE_ASSET__DwB2J8ox__"